/**
 * Chat History Styled Components
 */

import colors from '@hl/ui-components/styles/colors.scss';
import styled from 'styled-components';

import { IOcAppTheme, OcColors } from '../../config/ocTheme';

// History Container
export const HistoryContainer = styled.div`
  width: 230px;
  border: 1px solid ${({ theme }) => theme.color.chatBorder};
  background-color: ${({ theme }) => theme.color.chatBg};
  min-width: 1px;
  border-radius: 4px;
  flex-direction: column;
  display: flex;
`;

// History Header
export const HistoryHeader = styled.div`
  padding: 16px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-shrink: 0;
`;

export const HistoryHeaderText = styled.div`
  font-size: ${({ theme }) => theme.font.size.small};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  color: ${({ theme }) => (theme as IOcAppTheme).color.textMuted || OcColors.defaultText};
`;

// History List Container
export const HistoryListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 8px 8px 8px;
`;

// Skeleton Loading
export const SkeletonContainer = styled.div`
  padding: 8px;
`;

// Error and Empty States
export const ErrorMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: ${colors.redOrange};
  font-size: ${({ theme }) => theme.font.size.default};
`;

export const EmptyMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: ${({ theme }) => (theme as IOcAppTheme).color.textMuted || OcColors.metaText};
  font-size: ${({ theme }) => theme.font.size.default};
`;

